import React, {useEffect, useState} from "react";

const desktopPromoQuery = "(min-width: 1201px)";

function LoginLeftPart() {
  const [showDesktopPromo, setShowDesktopPromo] = useState(
    () => window.matchMedia(desktopPromoQuery).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(desktopPromoQuery);
    const updatePromoVisibility = ({matches}) => setShowDesktopPromo(matches);

    mediaQuery.addEventListener("change", updatePromoVisibility);
    return () => mediaQuery.removeEventListener("change", updatePromoVisibility);
  }, []);

  if (!showDesktopPromo) {
    return null;
  }

  return (
    <div className="wrap_alpha_serach">
      <img
        className="login_promo_panel"
        src="/Image/login-promo-panel.png"
        width={1024}
        height={970}
        alt="Using Data to bring transparency to the private markets. AlphaSearch platform preview with search results for private market companies"
      />
    </div>
  );
}

export default LoginLeftPart;
